import { gql } from '@apollo/client';

export const GET_PATIENTS = gql`
  query GetPatientPagination(
    $page: Int!
    $perPage: Int!
    $withCarePlan: Boolean
    $filter: GqlPatientFilter!
  ) {
    user {
      patient {
        patientPagination(
          page: $page
          perPage: $perPage
          withCarePlan: $withCarePlan
          filter: $filter
        ) {
          pageInfo {
            totalItems
            page
            perPage
            totalPages
            hasNextPage
            hasPreviousPage
          }
          items {
            id
            name {
              firstName
              lastName
            }
            email
            gender
            phone
            birthDate
            photoUrl
            birthPlace {
              country
              city
              address
              zipcode
            }
            careTeams {
              id
            }
            carePlans {
              items {
                title
                planDefinitionId
                patientId
                startDate
                engagement
                engagementRatio
                currentDay
                endDay
                status
                metrics {
                  metricDefinitionId
                  code
                  title
                  components {
                    __typename
                    code {
                      coding {
                        code
                        display
                        version
                        system
                      }
                      text
                    }
                    ... on GqlNumericObservationComponent {
                      value {
                        value
                        unit
                        system
                        code
                      }
                    }
                    ... on GqlScaleObservationComponent {
                      value {
                        value
                        unit
                        system
                        code
                      }
                    }
                  }
                  date
                }
              }
            }
          }
        }
      }
    }
  }
`;
